import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../..';

const StyledContentBox = styled.div`
  display: flex;
  flex-direction: column;
  background: ${Colors.white};
  padding: 1rem 2rem;
  width: 100%
`;

export const ContentBox: FC = (props) => {
  return (<StyledContentBox>
    {props.children}
  </StyledContentBox>);
};
